import { useEffect, useState, useContext } from "react";
import UserContext from "../../contexts/UserContext";
import $ from "jquery";
import {
    useNavigate
} from "react-router-dom";
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';

const UserPayment = () => {

const navigate = useNavigate();
  
const {user,setUser} = useContext(UserContext);
const [userPayments,setUserPayments] = useState(null);
const [isLoading, setLoading] = useState(true);
const [show, setShow] = useState(true);
const [totalTakhmeen,setTotalTakhmeen] = useState(null)

async function getDataForUser(){
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getUsersSession",
        xhrFields: {
            withCredentials: true  // Include cookies
        },
        crossDomain: true, 
        success : function(response){
        if(response && response.user){
            setUser(response.user);
        }else{
            setUser(null)
            navigate("/login");
        }

        },
        error: function(err){
            console.log("error")
            console.log(err)
        }
    })
}

async function getData(userId){
    await $.ajax({
        type:"GET",
        url:process.env.REACT_APP_API_URL+"/getUsers/"+userId,
        xhrFields: {
            withCredentials: true  // Include cookies
        },
        crossDomain: true, 
        success : function(response){
        if(response && response.user){
            setUser(response.user);
        }else{
            navigate("/login",{state:{message:"Please Login !"}})
        }

        },
        error: function(err){
            console.log("error")
            console.log(err)
            navigate("/login",{state:{message:"Something went wrong !"}})
        }
    })
}

const getUserPayments = async ()=>{
    await $.ajax({
      type:"GET",
      url:process.env.REACT_APP_API_URL+"/userPayments",
      xhrFields: {
          withCredentials: true  // Include cookies
        },
        crossDomain: true, 
       success : function(response){
        if(response.message){
            setUserPayments(null)
            setLoading(false)
        }else{
          setUserPayments(response);
          setLoading(false)
        }

      },
      error: function(err){
          console.log("error")
          console.log(err)
      }
  })
}

function calculateTotalTakhmeen(userData){
    if(totalTakhmeen === null){
        let totalAmount = 0;
        if(userData){
          userData.takhmeen.map((takhmeen)=>{
              totalAmount = takhmeen.amount + totalAmount;
          })
        }
        setTotalTakhmeen(totalAmount)
    }
    
}  

useEffect(() => {
    try{
        if(!user && (typeof localStorage !== 'undefined') && localStorage.getItem('userSession')){
          getData(JSON.parse(localStorage.getItem('userSession')))
        }else{
          if(!user){
            getDataForUser();
          }
        }
      }
      catch(e){
        getDataForUser();
      }
    getUserPayments();
},[])

const UserPaymentCard = ({info}) => {
    const design = (
        <>
        <div className="minimal-payment-card">
            <div className="payment-details">
                <div className="info-item">
                <span className="info-label">Date:</span>
                <span className="info-value">{info.date}</span>
                </div>
                <div className="info-item">
                <span className="info-label">Type:</span>
                <span className="info-value">{info.paymentType}</span>
                </div>
                <div className="info-item">
                <span className="info-label">Ref #:</span>
                <span className="info-value">{info.refNumber}</span>
                </div>
                <div className="info-item">
                <span className="info-label">Amount:</span>
                <span className="info-value">INR {info.amount}</span>
                </div>
                {
                    info.comments && info.comments.length>0?
                    <div className="info-item">
                    <span className="info-label">Comments:</span>
                    <span className="info-value">{info.comments}</span>
                    </div>:
                    null
                }
            </div>
        </div>
        </>
    )
    return design;
}

    const design = (
        <>
        {user && user.takhmeen && user.takhmeen.length>0?<div className="small-cards">
        <div className="card-sm-container">
            <div className="card-content">
            <p> Takhmeen<br/>{user.takhmeen[user.takhmeen.length-1].year}</p>
            <p className="amount">₹{user.takhmeen[user.takhmeen.length-1].amount}</p>
            </div>
        </div>
        {calculateTotalTakhmeen(user)}
        <div className="card-sm-container">
            <div className="card-content">
            <p>Total Hub Due</p>
            <p className="amount">₹{totalTakhmeen - user.hubPaid}</p>
            </div>
        </div>
        </div>:null}
        {
            userPayments && userPayments.payment.length>0?
            userPayments.payment.map((paymentInfo) => {
                return <UserPaymentCard info={paymentInfo}/>
            })
            :
            <Alert className="m-3" variant="danger" onClose={() => setShow(false)} dismissible>
            No Payment Info !
            </Alert>
        }
        </>
    )
    return isLoading? <div className="mx-auto mt-5" style={{width: "30px"}}><Spinner className="mx-auto " style={{color:'brown'}} animation="border" role="status">
    </Spinner><br/>
    <span style={{marginLeft:'-10px'}}>Loading...</span></div>: design;

}

export default UserPayment;